import { ApiErrorResponse } from '@hidayahlab/academy-suite-corelib';
import { useState } from 'react';

export const useHandleOtpState = () => {
  const [otpError, setOtpError] = useState('');
  const [disabledOtp, setDisabledOtp] = useState(false);
  const [isPending, setIsPending] = useState(false);

  const handleOtpError = (error: ApiErrorResponse['data']['error']) => {
    if (error === 'MaximumVerificationAttemptsExceededException') {
      setOtpError(
        'আপনি সর্বাধিক বার চেষ্টা করেছেন, দয়া কোরে নতুন OTP অনুরোধ করুন।',
      );
      setDisabledOtp(true);
    }

    if (error === 'OtpExpiredException') {
      setOtpError('আপনার OTP এর সময় শেষ হয়ে গেছে');
      setDisabledOtp(true);
    }

    if (error === 'MalformedOtpException') {
      setOtpError('আপনার OTP সঠিক হয় নি');
    }
  };

  const clearOtpError = () => {
    setOtpError('');
  };

  return {
    otpError,
    handleOtpError,
    clearOtpError,
    setOtpError,
    disabledOtp,
    setDisabledOtp,
    isPending,
    setIsPending,
  };
};
